import React from 'react'
import NavbarTop from './../components/global/NavbarTop';
import PricingContent from '../components/Pricing/PricingContent';

const Pricing = (props) => {
  return (
    <>
        <NavbarTop/>
        <PricingContent id={props.id}/>
    </>
  )
}

export default Pricing